import { Component } from 'preact'
import { isInputEl } from '../../libs/typeGuards'
import InputGroup from '../../control-components/ui-components/InputGroup'
import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import { ItemsList, Item } from '../dropdown/interfaces'
import { IdeaStatus } from '../../control-components/ideation-status/Types'
import axios from 'axios'

interface Props {
  column_1: number
  column_2: number
  column_3: number
  maxHeight: number
  onChange: (state: {column_1: number, column_2: number, column_3: number, maxHeight: number}) => void
}

interface State {
  column_1: number
  column_2: number
  column_3: number
  maxHeight: number
  ideaStatusList: IdeaStatus[]
}

export class PipelineConfigurator extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      column_1: props.column_1,
      column_2: props.column_2,
      column_3: props.column_3,
      maxHeight: props.maxHeight,
      ideaStatusList: []
    }
  }

  async componentDidMount () {
    const { data } = await axios.get('/community/api/ideas/ideaStatuses')
    if (!data.result.length) {
      return
    }

    this.setState({ ideaStatusList: data.result })
  }

  onChangeMaxHeight(mh: number) {
    this.setState({
      maxHeight: mh
    }, this.notifyChanges)
  }

  onChangeColumn (key: 'column_1'| 'column_2' | 'column_3', value: number) {
    const newState = { ...this.state }
    newState[key] = value
    this.setState(newState, this.notifyChanges)
  }

  notifyChanges () {
    this.props.onChange(this.state)
  }

  ideationStatuses (onChange: (value: string) => void) {
    return this.state.ideaStatusList.map((status: IdeaStatus): Item => {
      return {
        value: status.id,
        title: status.name,
        onClick: (e: Event) => onChange((e.target as HTMLElement).getAttribute('value') as string),
        variant: 'primary'
      }
    })
  }

  getIdeationStatusDropdownTitle (column: number) {
    const items: IdeaStatus[] = this.state.ideaStatusList.filter((status: IdeaStatus) => `${status.id}` === column.toString())

    if (items.length < 1) {
      return 'Choose ideation status'
    }

    return items[0].name
  }

  render () {
    const { maxHeight } = this.state
    return (
      <div className='pipeline-widget__configurator'>
        <InputGroup
          title='Ideation status for first column' customInput={
            <DropdownControl
              triggerClass='ideation-status-dropdown form-group'
              align='adjust'
              trigger={<ButtonControl
                title={this.getIdeationStatusDropdownTitle(this.state.column_1)}
                icon='arrowDropdown'
                       />}
              items={this.ideationStatuses((value: string) => this.onChangeColumn('column_1', parseInt(value))) as ItemsList}
              hasSearch={false}
            />
        }
        />
        <InputGroup
          title='Ideation status for second column' customInput={
            <DropdownControl
              triggerClass='ideation-status-dropdown form-group'
              align='adjust'
              trigger={<ButtonControl
                title={this.getIdeationStatusDropdownTitle(this.state.column_2)}
                icon='arrowDropdown'
                       />}
              items={this.ideationStatuses((value: string) => this.onChangeColumn('column_2', parseInt(value))) as ItemsList}
              hasSearch={false}
            />
        }
        />
        <InputGroup
          title='Ideation status for third column' customInput={
            <DropdownControl
              triggerClass='ideation-status-dropdown form-group'
              align='adjust'
              trigger={<ButtonControl
                title={this.getIdeationStatusDropdownTitle(this.state.column_3)}
                icon='arrowDropdown'
                       />}
              items={this.ideationStatuses((value: string) => this.onChangeColumn('column_3', parseInt(value))) as ItemsList}
              hasSearch={false}
            />
        }
        />

        <div className='ideation-pipeline__max-list-height'>
          <p className='ideation-pipeline__max-list-height-text'>
            <label>Maximum list height</label>
            <span>
              <input
                type='number'
                onChange={(e) => {
                  if (!isInputEl(e.target)) return
                  this.onChangeMaxHeight(parseInt(e.target.value, 10))
                }}
                value={maxHeight}
                min={0}
              />
              px
            </span>
          </p>
        </div>

      </div>
    )
  }
}

export default PipelineConfigurator
